<template>
<div>
    <h2>{{props.status.name}}</h2>

    <div>Начислено вознаграждение - <b>{{props.reward.sum}}р</b></div>

    <div v-if="props.status.detail" v-html="props.status.detail"></div>

    <ButMes @input="start" :ob="finob" text="Подтвердить" />

</div>
</template>

<style lang="scss">
    .btn--pered {
        margin-top: 20px;
    }
</style>

<script setup>
import {confirmFinishClaim} from '@/actions.js'
import {reactive} from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
import ButMes from '@/comp/Payout/ButMes.vue'
import {ReplaceToMain} from '@/payout/util.js'

const router = useRouter()
const route = useRoute()

const props = defineProps({
  claim: Object,
  status: Object, 
  reward: Object, 
})

const finob = reactive({
  finish : false,
  wait: false,
  message: '',
})

const start = () => {
    if (finob.wait) {
        return
    }
    finob.wait = true
    finob.message = ''
    let claim_num = props.claim.num

    confirmFinishClaim({claim_num}).then( ({finish})=> {
        finob.finish = finish
        finob.wait = false
        ReplaceToMain( {route, router} )
    }, message => {
        finob.wait = false
        finob.message = `Не удалось: ${message}`
    } )

}


</script>


